import { createContext } from "@/hooks/contexts.ts";

export const THEME_LOCAL_STORAGE_KEY = "theme";

export interface IThemeContext {
  theme: "light" | "dark";
  setTheme: (next: "light" | "dark") => void;
  switchTheme: () => void;
}

export const ThemeContext = createContext<IThemeContext>({
  theme: (localStorage.getItem(THEME_LOCAL_STORAGE_KEY) ?? "light") as "light" | "dark",
  setTheme() {},
  switchTheme() {},
});
